import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  collectionGroup,
  Timestamp, 
  doc, 
  addDoc,
  updateDoc,
  getDoc,
  setDoc,
  getDocs,
  where, 
  startAfter, 
  limit, 
  orderBy,
  startAt,
  endAt,
  query,
  Query,
  increment,
  arrayUnion,
  onSnapshot,
  Unsubscribe,
  writeBatch,
} from "firebase/firestore";
import { getMessaging, Messaging, onMessage, getToken } from "firebase/messaging";
import {
  getAuth, 
  setPersistence, 
  browserLocalPersistence, 
  signInWithEmailAndPassword,
  confirmPasswordReset,
  reauthenticateWithCredential,
  onAuthStateChanged,
  EmailAuthProvider,
  updatePassword,
  signOut,
} from "firebase/auth";
import { getStorage, ref as refStorage, uploadBytes, getDownloadURL, getBlob, deleteObject } from "firebase/storage";

import firebaseConfig from './config/firebaseConfig';
import urls from './constants/urls';
import { isDev } from './config';

export const firebaseFunctionUrl = urls.api[isDev ? 'staging' : 'production']


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

const auth = getAuth(app);

const firebaseStorage = getStorage(app);

const messaging: Messaging | null = getMessaging(app);

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export const onNotificationListener = (callback: () => void): Unsubscribe => {
  return onSnapshot(query(collection(db, "notification")), (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added" || change.type === 'modified') {
        callback();
      }
    });
  }, (error) => {
    console.error(error);
  });
};

export {
  collection,
  collectionGroup,
  firebaseStorage,
  refStorage,
  getDownloadURL,
  uploadBytes,
  getBlob,
  db,
  addDoc,
  updateDoc,
  doc,
  setDoc,
  getDoc,
  getDocs,
  where,
  orderBy,
  startAt,
  endAt,
  startAfter,
  limit,
  query,
  auth,
  setPersistence,
  browserLocalPersistence,
  signInWithEmailAndPassword,
  confirmPasswordReset,
  reauthenticateWithCredential,
  onAuthStateChanged,
  EmailAuthProvider,
  updatePassword,
  signOut,
  Timestamp,
  Query,
  increment,
  arrayUnion,
  messaging,
  getToken,
  deleteObject,
  writeBatch,
};
